import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import router from "@/router";
import { useUserStore } from "@/store/user";
import { useCoachStore } from "@/store/coach";
import { useChatStore } from "@/store/chat";
import { useSupportChat } from "@/composables/useSupportChat";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props, { expose }) {
  expose();

const userStore = useUserStore();
const coachStore = useCoachStore();
const chatStore = useChatStore();
const { isSignedAtTermsOfUse, isCoach } = useSupportChat();

const coachNavigationList = [
  {
    title: "Support Requests",
    route: "/support-requests",
    class: "support-chat",
  },
  {
    title: "Personal chats",
    route: "/personal-chats",
    class: "support-chat",
  },
];
const userNavigationList = [
  {
    title: "Dashboard",
    route: "/dashboard",
    class: "dashboard",
  },
  {
    title: "Workouts",
    route: "/workouts",
    class: "myclubhouse",
  },
  {
    title: "Nutrition",
    route: "/nutrition",
    class: "nutrition",
  },
  {
    title: "My Resources",
    route: "/resources",
    class: "resources",
  },
  {
    title: "Support Chat",
    route: "/support-chat",
    class: "support-chat",
  },
];
const isUser = computed(
  () => userStore.data.roles && userStore.data.roles.includes("user")
);
const getNavigationList = computed(() =>
  isUser.value ? userNavigationList : coachNavigationList
);

const __returned__ = { userStore, coachStore, chatStore, isSignedAtTermsOfUse, isCoach, coachNavigationList, userNavigationList, isUser, getNavigationList, computed, router, useUserStore, useCoachStore, useChatStore, useSupportChat }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})